// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inputNew-module_root__ryGYA {
    /* border & radius */
    --ci-radius: 8px;
    --ci-height: auto;
    /* background & text — these already reflect the active error/disabled state (see buildInputCssVarsNew) */
    --ci-bg: transparent;
    --ci-text-color: inherit;
    --ci-text-color-hover: var(--ci-text-color);
    --ci-caret-color: currentColor;
    --ci-text-align: left;
    /* outline — focus keeps its own var since focus isn't part of the error/disabled state */
    --ci-outline-color: rgba(0, 0, 0, 0.38);
    --ci-outline-color-focus: #1976d2;
    /* label */
    --ci-label-color: rgba(0, 0, 0, 0.6);
    --ci-label-color-focus: #1976d2;
    /* indicator */
    --ci-indicator-color: var(--ci-outline-color);
    --ci-indicator-color-focus: var(--ci-outline-color-focus);
    /* helper */
    --ci-helper-color: rgba(0, 0, 0, 0.6);
    /* typography */
    --ci-font-family: inherit;
    --ci-font-weight: inherit;
    --ci-font-size: 1rem;
    --ci-line-height: 1.5;
    --ci-font-size-xl: initial;
    --ci-line-height-xl: initial;
    --ci-letter-spacing: normal;
    /* spacing */
    --ci-margin-top: 0;
    --ci-margin-right: 0;
    --ci-margin-bottom: 0;
    --ci-margin-left: 0;
    --ci-padding-top: 16px;
    --ci-padding-right: 14px;
    --ci-padding-bottom: 16px;
    --ci-padding-left: 14px;

    display: inline-flex;
    flex-direction: column;
    width: fit-content;
    font-family: var(--ci-font-family), sans-serif;
    font-weight: var(--ci-font-weight);
    font-size: var(--ci-font-size);
    line-height: var(--ci-line-height);
    letter-spacing: var(--ci-letter-spacing);
    padding: var(--ci-margin-top) var(--ci-margin-right) var(--ci-margin-bottom) var(--ci-margin-left);
    box-sizing: border-box;
}

.inputNew-module_root__ryGYA[data-full-width='true'] {
    width: 100%;
}

/* wraps only the field itself (outline, label, control, indicator) so the
   helper/error text below is never enclosed by the outline or indicator */
.inputNew-module_field__An9Dk {
    position: relative;
}

/* container outline (notched, so the floated label can sit "on" the border) */
.inputNew-module_frame__PFDke {
    display: block;
    position: absolute;
    inset: -5px 0 0 0;
    border: 1px solid var(--ci-outline-color);
    border-bottom-color: var(--ci-indicator-color);
    border-radius: var(--ci-radius);
    pointer-events: none;
    margin: 0;
    padding: 0 8px;
    transition: border-color 0.15s, border-width 0.05s;
}
.inputNew-module_root__ryGYA[data-disabled='true'] .inputNew-module_frame__PFDke{
    border-bottom-color: var(--ci-outline-color);
}

.inputNew-module_notch__CERBk {
    visibility: hidden;
    display: block;
    height: 11px;
    max-width: 0.01px;
    white-space: nowrap;
    padding: 0;
    overflow: hidden;
    transition: max-width 0.1s cubic-bezier(0, 0, 0.2, 1);
}

.inputNew-module_root__ryGYA[data-floated='true'] .inputNew-module_notch__CERBk {
    max-width: min-content;
    padding: 0 4px;
}

/* focus thickens/tints the outline; skipped in error so the frame stays a plain
   thin, error-tinted border and the bold indicator strip carries the emphasis */
.inputNew-module_root__ryGYA[data-focused='true']:not([data-error='true']) .inputNew-module_frame__PFDke {
    border-bottom-color: var(--ci-outline-color-focus);
}

.inputNew-module_root__ryGYA[data-variant='filled'] .inputNew-module_frame__PFDke {
    display: none;
}

/* native control */
.inputNew-module_control__v4EJ0 {
    all: unset;
    box-sizing: border-box;
    width: 100%;
    height: var(--ci-height);
    cursor: auto;
    color: var(--ci-text-color);
    caret-color: var(--ci-caret-color);
    text-align: var(--ci-text-align);
    padding: var(--ci-padding-top) var(--ci-padding-right) var(--ci-padding-bottom) var(--ci-padding-left);
    border-radius: var(--ci-radius);
    transition: color 0.15s;
}

.inputNew-module_control__v4EJ0::-webkit-outer-spin-button,
.inputNew-module_control__v4EJ0::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.inputNew-module_control__v4EJ0[type="number"] {
    -moz-appearance: textfield;
}

@media screen and (min-width: 1920px) {
    .inputNew-module_control__v4EJ0 {
        font-size: var(--ci-font-size-xl, var(--ci-font-size));
        line-height: var(--ci-line-height-xl, var(--ci-line-height));
    }
}

.inputNew-module_hoverTint__vi4dP:focus {
    color: var(--ci-text-color-hover);
}

/* Touch browsers emulate a sticky :hover after a tap/long press — apply hover only for real pointers. */
@media (hover: hover) and (pointer: fine) {
    .inputNew-module_hoverTint__vi4dP:hover {
        color: var(--ci-text-color-hover);
    }
}

.inputNew-module_control__v4EJ0:disabled {
    cursor: not-allowed;
}

.inputNew-module_root__ryGYA[data-variant='filled'] .inputNew-module_control__v4EJ0 {
    background-color: var(--ci-bg);
    padding-top: calc(var(--ci-padding-top) + 8px);
    padding-bottom: max(calc(var(--ci-padding-bottom) - 8px), 8px);
}

/* floating label */
.inputNew-module_label__V7XnR {
    position: absolute;
    left: var(--ci-padding-left);
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: calc(100% - var(--ci-padding-left) - var(--ci-padding-right) - 4px);
    transform-origin: left top;
    transition: transform 0.15s cubic-bezier(0, 0, 0.2, 1), font-size 0.15s cubic-bezier(0, 0, 0.2, 1), color 0.15s, top 0.15s cubic-bezier(0, 0, 0.2, 1);
}

.inputNew-module_root__ryGYA[data-floated='true'] .inputNew-module_label__V7XnR {
    top: 0;
}

.inputNew-module_root__ryGYA[data-variant='filled'][data-floated='true'] .inputNew-module_label__V7XnR {
    top: 8px;
    transform: none;
}

.inputNew-module_root__ryGYA[data-focused='true']:not([data-error='true']) .inputNew-module_label__V7XnR {
    color: var(--ci-label-color-focus);
}

/* active indicator (bottom line) */
.inputNew-module_indicator__fkssI {
    position: absolute;
    left: calc(var(--ci-radius) / 1.6);
    bottom: 1px;
    height: 1px;
    width: calc(100% - var(--ci-radius) * 1.2);
    background-color: var(--ci-indicator-color);
    transform: scaleX(0);
    transition: transform 0.15s cubic-bezier(0, 0, 0.2, 1), background-color 0.15s;
}

.inputNew-module_root__ryGYA[data-variant='filled'] .inputNew-module_indicator__fkssI {
    transform: scaleX(1);
}

.inputNew-module_root__ryGYA[data-focused='true']:not([data-error='true']) .inputNew-module_indicator__fkssI {
    transform: scaleX(1);
    background-color: var(--ci-indicator-color-focus);
}

.inputNew-module_root__ryGYA[data-error='true'] .inputNew-module_indicator__fkssI {
    transform: scaleX(1);
}

.inputNew-module_root__ryGYA[data-disabled='true'] .inputNew-module_frame__PFDke {
    border-style: dashed;
}

/* helper text */
.inputNew-module_helper__nlUw7 {
    margin: 4px 14px 0;
    color: var(--ci-helper-color);
}
`, "",{"version":3,"sources":["webpack://./../../packages/core-widgets/src/input/inputNew.module.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,iBAAiB;IACjB,yGAAyG;IACzG,oBAAoB;IACpB,wBAAwB;IACxB,2CAA2C;IAC3C,8BAA8B;IAC9B,qBAAqB;IACrB,yFAAyF;IACzF,uCAAuC;IACvC,iCAAiC;IACjC,UAAU;IACV,oCAAoC;IACpC,+BAA+B;IAC/B,cAAc;IACd,6CAA6C;IAC7C,yDAAyD;IACzD,WAAW;IACX,qCAAqC;IACrC,eAAe;IACf,yBAAyB;IACzB,yBAAyB;IACzB,oBAAoB;IACpB,qBAAqB;IACrB,0BAA0B;IAC1B,4BAA4B;IAC5B,2BAA2B;IAC3B,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,qBAAqB;IACrB,mBAAmB;IACnB,sBAAsB;IACtB,wBAAwB;IACxB,yBAAyB;IACzB,uBAAuB;;IAEvB,oBAAoB;IACpB,sBAAsB;IACtB,kBAAkB;IAClB,8CAA8C;IAC9C,kCAAkC;IAClC,8BAA8B;IAC9B,kCAAkC;IAClC,wCAAwC;IACxC,kGAAkG;IAClG,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;0EAC0E;AAC1E;IACI,kBAAkB;AACtB;;AAEA,8EAA8E;AAC9E;IACI,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,yCAAyC;IACzC,8CAA8C;IAC9C,+BAA+B;IAC/B,oBAAoB;IACpB,SAAS;IACT,cAAc;IACd,kDAAkD;AACtD;AACA;IACI,4CAA4C;AAChD;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,qDAAqD;AACzD;;AAEA;IACI,sBAAsB;IACtB,cAAc;AAClB;;AAEA;gFACgF;AAChF;IACI,kDAAkD;AACtD;;AAEA;IACI,aAAa;AACjB;;AAEA,mBAAmB;AACnB;IACI,UAAU;IACV,sBAAsB;IACtB,WAAW;IACX,wBAAwB;IACxB,YAAY;IACZ,2BAA2B;IAC3B,kCAAkC;IAClC,gCAAgC;IAChC,sGAAsG;IACtG,+BAA+B;IAC/B,uBAAuB;AAC3B;;AAEA;;IAEI,wBAAwB;IACxB,SAAS;AACb;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI;QACI,sDAAsD;QACtD,4DAA4D;IAChE;AACJ;;AAEA;IACI,iCAAiC;AACrC;;AAEA,wGAAwG;AACxG;IACI;QACI,iCAAiC;IACrC;AACJ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,8CAA8C;IAC9C,8DAA8D;AAClE;;AAEA,mBAAmB;AACnB;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,QAAQ;IACR,2BAA2B;IAC3B,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,8EAA8E;IAC9E,0BAA0B;IAC1B,qJAAqJ;AACzJ;;AAEA;IACI,MAAM;AACV;;AAEA;IACI,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,kCAAkC;AACtC;;AAEA,mCAAmC;AACnC;IACI,kBAAkB;IAClB,kCAAkC;IAClC,WAAW;IACX,WAAW;IACX,0CAA0C;IAC1C,2CAA2C;IAC3C,oBAAoB;IACpB,8EAA8E;AAClF;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;IACpB,iDAAiD;AACrD;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA,gBAAgB;AAChB;IACI,kBAAkB;IAClB,6BAA6B;AACjC","sourcesContent":[".root {\n    /* border & radius */\n    --ci-radius: 8px;\n    --ci-height: auto;\n    /* background & text — these already reflect the active error/disabled state (see buildInputCssVarsNew) */\n    --ci-bg: transparent;\n    --ci-text-color: inherit;\n    --ci-text-color-hover: var(--ci-text-color);\n    --ci-caret-color: currentColor;\n    --ci-text-align: left;\n    /* outline — focus keeps its own var since focus isn't part of the error/disabled state */\n    --ci-outline-color: rgba(0, 0, 0, 0.38);\n    --ci-outline-color-focus: #1976d2;\n    /* label */\n    --ci-label-color: rgba(0, 0, 0, 0.6);\n    --ci-label-color-focus: #1976d2;\n    /* indicator */\n    --ci-indicator-color: var(--ci-outline-color);\n    --ci-indicator-color-focus: var(--ci-outline-color-focus);\n    /* helper */\n    --ci-helper-color: rgba(0, 0, 0, 0.6);\n    /* typography */\n    --ci-font-family: inherit;\n    --ci-font-weight: inherit;\n    --ci-font-size: 1rem;\n    --ci-line-height: 1.5;\n    --ci-font-size-xl: initial;\n    --ci-line-height-xl: initial;\n    --ci-letter-spacing: normal;\n    /* spacing */\n    --ci-margin-top: 0;\n    --ci-margin-right: 0;\n    --ci-margin-bottom: 0;\n    --ci-margin-left: 0;\n    --ci-padding-top: 16px;\n    --ci-padding-right: 14px;\n    --ci-padding-bottom: 16px;\n    --ci-padding-left: 14px;\n\n    display: inline-flex;\n    flex-direction: column;\n    width: fit-content;\n    font-family: var(--ci-font-family), sans-serif;\n    font-weight: var(--ci-font-weight);\n    font-size: var(--ci-font-size);\n    line-height: var(--ci-line-height);\n    letter-spacing: var(--ci-letter-spacing);\n    padding: var(--ci-margin-top) var(--ci-margin-right) var(--ci-margin-bottom) var(--ci-margin-left);\n    box-sizing: border-box;\n}\n\n.root[data-full-width='true'] {\n    width: 100%;\n}\n\n/* wraps only the field itself (outline, label, control, indicator) so the\n   helper/error text below is never enclosed by the outline or indicator */\n.field {\n    position: relative;\n}\n\n/* container outline (notched, so the floated label can sit \"on\" the border) */\n.frame {\n    display: block;\n    position: absolute;\n    inset: -5px 0 0 0;\n    border: 1px solid var(--ci-outline-color);\n    border-bottom-color: var(--ci-indicator-color);\n    border-radius: var(--ci-radius);\n    pointer-events: none;\n    margin: 0;\n    padding: 0 8px;\n    transition: border-color 0.15s, border-width 0.05s;\n}\n.root[data-disabled='true'] .frame{\n    border-bottom-color: var(--ci-outline-color);\n}\n\n.notch {\n    visibility: hidden;\n    display: block;\n    height: 11px;\n    max-width: 0.01px;\n    white-space: nowrap;\n    padding: 0;\n    overflow: hidden;\n    transition: max-width 0.1s cubic-bezier(0, 0, 0.2, 1);\n}\n\n.root[data-floated='true'] .notch {\n    max-width: min-content;\n    padding: 0 4px;\n}\n\n/* focus thickens/tints the outline; skipped in error so the frame stays a plain\n   thin, error-tinted border and the bold indicator strip carries the emphasis */\n.root[data-focused='true']:not([data-error='true']) .frame {\n    border-bottom-color: var(--ci-outline-color-focus);\n}\n\n.root[data-variant='filled'] .frame {\n    display: none;\n}\n\n/* native control */\n.control {\n    all: unset;\n    box-sizing: border-box;\n    width: 100%;\n    height: var(--ci-height);\n    cursor: auto;\n    color: var(--ci-text-color);\n    caret-color: var(--ci-caret-color);\n    text-align: var(--ci-text-align);\n    padding: var(--ci-padding-top) var(--ci-padding-right) var(--ci-padding-bottom) var(--ci-padding-left);\n    border-radius: var(--ci-radius);\n    transition: color 0.15s;\n}\n\n.control::-webkit-outer-spin-button,\n.control::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\n.control[type=\"number\"] {\n    -moz-appearance: textfield;\n}\n\n@media screen and (min-width: 1920px) {\n    .control {\n        font-size: var(--ci-font-size-xl, var(--ci-font-size));\n        line-height: var(--ci-line-height-xl, var(--ci-line-height));\n    }\n}\n\n.hoverTint:focus {\n    color: var(--ci-text-color-hover);\n}\n\n/* Touch browsers emulate a sticky :hover after a tap/long press — apply hover only for real pointers. */\n@media (hover: hover) and (pointer: fine) {\n    .hoverTint:hover {\n        color: var(--ci-text-color-hover);\n    }\n}\n\n.control:disabled {\n    cursor: not-allowed;\n}\n\n.root[data-variant='filled'] .control {\n    background-color: var(--ci-bg);\n    padding-top: calc(var(--ci-padding-top) + 8px);\n    padding-bottom: max(calc(var(--ci-padding-bottom) - 8px), 8px);\n}\n\n/* floating label */\n.label {\n    position: absolute;\n    left: var(--ci-padding-left);\n    top: 50%;\n    transform: translateY(-50%);\n    pointer-events: none;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: calc(100% - var(--ci-padding-left) - var(--ci-padding-right) - 4px);\n    transform-origin: left top;\n    transition: transform 0.15s cubic-bezier(0, 0, 0.2, 1), font-size 0.15s cubic-bezier(0, 0, 0.2, 1), color 0.15s, top 0.15s cubic-bezier(0, 0, 0.2, 1);\n}\n\n.root[data-floated='true'] .label {\n    top: 0;\n}\n\n.root[data-variant='filled'][data-floated='true'] .label {\n    top: 8px;\n    transform: none;\n}\n\n.root[data-focused='true']:not([data-error='true']) .label {\n    color: var(--ci-label-color-focus);\n}\n\n/* active indicator (bottom line) */\n.indicator {\n    position: absolute;\n    left: calc(var(--ci-radius) / 1.6);\n    bottom: 1px;\n    height: 1px;\n    width: calc(100% - var(--ci-radius) * 1.2);\n    background-color: var(--ci-indicator-color);\n    transform: scaleX(0);\n    transition: transform 0.15s cubic-bezier(0, 0, 0.2, 1), background-color 0.15s;\n}\n\n.root[data-variant='filled'] .indicator {\n    transform: scaleX(1);\n}\n\n.root[data-focused='true']:not([data-error='true']) .indicator {\n    transform: scaleX(1);\n    background-color: var(--ci-indicator-color-focus);\n}\n\n.root[data-error='true'] .indicator {\n    transform: scaleX(1);\n}\n\n.root[data-disabled='true'] .frame {\n    border-style: dashed;\n}\n\n/* helper text */\n.helper {\n    margin: 4px 14px 0;\n    color: var(--ci-helper-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `inputNew-module_root__ryGYA`,
	"field": `inputNew-module_field__An9Dk`,
	"frame": `inputNew-module_frame__PFDke`,
	"notch": `inputNew-module_notch__CERBk`,
	"control": `inputNew-module_control__v4EJ0`,
	"hoverTint": `inputNew-module_hoverTint__vi4dP`,
	"label": `inputNew-module_label__V7XnR`,
	"indicator": `inputNew-module_indicator__fkssI`,
	"helper": `inputNew-module_helper__nlUw7`
};
export default ___CSS_LOADER_EXPORT___;
